import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ShopHomeService } from 'src/app/shop/pages/shop-home/shop-home.service';
import { DynamicContentService } from '../../services/dynamic-content/dynamic-content.service';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'sweepsbucks-menu',
    templateUrl: './sweepsbucks-menu.html',
    styleUrls: ['./sweepsbucks-menu.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SweepsbucksMenuComponent implements OnInit, OnDestroy {
    customSweepBuckMenuClasses: CustomSweepbuckMenuClass[] = [];
    headerHeight = 0;
    routerSubscription: Subscription;

    constructor(
        private navCtrl: NavController,
        private dynamicContentService: DynamicContentService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.headerHeight = document.getElementById('header').getBoundingClientRect().height;
        this.routerSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
        ).subscribe(() => this.closeMenu());
    }

    closeMenu() {
        this.dynamicContentService.closeSweepbuckMenu();
    }

    async goToAnotherPage(url: string){
        if (this.router.url.includes(url)) {
            this.closeMenu();
            return;
        }
        await this.navCtrl.navigateRoot(url);
    }

    getTopPosition(): string {
        return `calc(0px - ${this.headerHeight}px)`;
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) this.routerSubscription.unsubscribe();
    }
}

export type CustomSweepbuckMenuClass = 'lobby-home' | 'shop';
